import classnames from 'classnames';
import type { FC } from 'react';
import React, { useContext } from 'react';

import {
  RicosAlignmentContext,
  RicosNodeContextProvider,
  VisibleIndentationContext,
  VisibleIndentationContextProvider,
} from './../../../../../ricos-context/index.js';
import { TextStyle_TextAlignment } from './../../../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../../../../ricos-types/index.js';

import alignmentStyle from '../../../../statics/alignment-scss.js';
import styles from './lists-scss.js';

const BulletedList: FC<NodeViewRendererProps> = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { textAlignment } = useContext(RicosAlignmentContext);
  const { visibleIndentation } = useContext(VisibleIndentationContext);

  const currIndentation = visibleIndentation?.indentation || 0;
  const currOffset = node.bulletedListData?.offset || 0;

  const indentation =
    (visibleIndentation && visibleIndentation?.nodeId !== node.id ? 1 : 0) +
    currIndentation +
    currOffset;

  const bulletedListClassName = classnames(
    styles.bulletedlist,
    alignmentStyle[textAlignment || TextStyle_TextAlignment.AUTO]
  );

  return (
    <ul className={bulletedListClassName}>
      <VisibleIndentationContextProvider visibleIndentation={{ indentation, nodeId: node.id }}>
        <RicosNodeContextProvider parentNode={node} parentIndex={nodeIndex}>
          <RicosNodesRenderer nodes={node.nodes ?? []} />
        </RicosNodeContextProvider>
      </VisibleIndentationContextProvider>
    </ul>
  );
};

const BulletedListRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <BulletedList key={node.id} node={node} {...props} />;
};

export default BulletedListRenderer;
